import axios from 'axios';

const baseURL = "https://helpchatapi.brainbowedutech.com/public/api";
// export const axios_get = async (is_token = false, endPoint, params = "") => {
//     let auth_headers = '';
//     if (is_token) {
//         const token = localStorage.getItem('token');
//         auth_headers = { "Authorization": `${token}` }
//     }
//     let headers = {
//         "Content-Type": "application/json",
//         "Access-Control-Allow-Origin": "*",
//         ...auth_headers
//     };
//     try {
//         const instance = await axios.get(baseURL + endPoint, { ...headers });
//         let response = instance.data ? instance.data : {};
//         return response
//     } catch (error) {
//         if (error.status == 401) {
//             await localStorageClear();
//             window.location.href = "/login";
//         }
//         return error?.response?.data
//     }
// }


export const axios_post = async (is_token = false, endPoint, params = {}) => {
    // const token = localStorage.getItem('token');
    let auth_headers = '';
    if (is_token) {
        const token = localStorage.getItem('token');
        auth_headers = { "Authorization": `${token}` }
    }
    let headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        ...auth_headers
    };
    try {
        const instance = await axios.post(baseURL + endPoint, params, { headers: headers });
        let response = instance.data ? instance.data : {};
        return response
    } catch (error) {
        return error?.response?.data
    }
}

// export const axios_post_admin = async (is_token = false, endPoint, params = {}) => {
//     // const token = localStorage.getItem('token');
//     let auth_headers = '';
//     if (is_token) {
//         const token = localStorage.getItem('token');
//         auth_headers = { "Authorization": `${token}` }
//     }
//     let headers = {
//         "Content-Type": "application/json",
//         "Access-Control-Allow-Origin": "*",
//         ...auth_headers
//     };
//     try {
//         const instance = await axios.post(baseURL + endPoint, params, { headers: headers });
//         let response = instance.data ? instance.data : {};
//         return response
//     } catch (error) {
//         if(error.status == 401){
//             localStorageClear();
//             window.location.href = "/login";
//         }
//         return error?.response?.data
//     }
// }

// export const axios_post_Body = async (is_token = false, endPoint, params = {}) => {
//     let auth_headers = '';
//     if (is_token) {
//         const token = localStorage.getItem('token');
//         auth_headers = { "Authorization": `${token}` }
//     }
//     let headers = {
//         "Content-Type": "multipart/form-data",
//         "Access-Control-Allow-Origin": "*",
//         ...auth_headers
//     };
//     try {
//         const instance = await axios.post(baseURL + endPoint, params, { headers: headers });
//         let response = instance.data ? instance.data : {};
//         return response
//     } catch (error) {
//         if (error.status == 401) {
//             await localStorageClear();
//             window.location.href = "/login";
//         }
//         return error?.response?.data
//     }
// }